var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertificados(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19.745,
    viewBox: "0 0 16 19.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478,377.772V363.9a.994.994,0,0,0-1-.987H467a.994.994,0,0,0-1,.987v13.876l5.419-3.821a1.011,1.011,0,0,1,1.162,0Zm-6-1.8-6.419,4.526a1,1,0,0,1-1.581-.8V363.9a2.981,2.981,0,0,1,3-2.961h10a2.981,2.981,0,0,1,3,2.961v15.794a1,1,0,0,1-1.581.8Z",
    transform: "translate(-464 -360.935)",
    fill: "#c2c4d4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificados);
export default __webpack_public_path__ + "static/media/Certificados.0902c0d42b34913082427fde339e48ff.svg";
export { ForwardRef as ReactComponent };